<template>
        <div class="ibox form">
            <div class="ibox-title ibox-grey">
                <h4>{{ __(sectionTitle) }}</h4>
                <slot name="help"></slot>
            </div>

            <register-user-form
                :disabled="false"
                :box-title="''"
                :copy-client-data-button="true"
                @copy="copyClientData"
                @copyData="copyData"
                :country-translations="countryTranslations"
                :viesButton="true"
                ref="first_form"
                :index="0"></register-user-form>
            <register-user-form
                ref="secondary_form"
                :disabled="false"
                :box-title="__('user_data_form')"
                :copy-client-data-button="false"
                :viesButton="false"
                :index="1"
                v-show="formData.isDataCopied"></register-user-form>

        </div>

</template>

<script>
import {mapGetters, mapActions} from "vuex";
import InputWrapper from "../../form/InputWrapper.vue";
import permissions from './../../../services/Permissions.js';
import RegisterUserForm from "./RegisterUserForm";
import ClientDataForm from "./ClientDataForm";

export default {
    components: {
        RegisterUserForm,
        InputWrapper
    },
    data() {
        return {
            idVies: false,
            clientsForms: [],
            idSecondaryVies: false,
            isCopyClientData: false,
            formData: {
                name: "",
                countrySelected: null,
                idNumberType: null,
                idNumber: "",
                idNumberSecondaryType: "",
                idNumberSecondary: "",
                address1: "",
                address2: "",
                zip: "",
                city: "",
                remarks: "",
                departmentCountryChecked: false,
                departmentCountrySelected: null,
                short_name: "",
                isDataCopied:false
            },
            clearFormData: {
                name: "",
                countrySelected: null,
                idNumberType: null,
                idNumber: "",
                idNumberSecondaryType: "",
                idNumberSecondary: "",
                address1: "",
                address2: "",
                zip: "",
                city: "",
                remarks: "",
                departmentCountryChecked: false,
                departmentCountrySelected: null,
                short_name: "",
                isDataCopied:false
            }
        };
    },
    props: {
        errors: {
            default: () => ({})
        },
        idNumbers: {
            type: Array,
            default: () => []
        },
        countries: {
            type: Array,
            default: () => ({})
        },
        countryTranslations: {
            type: Object,
            default: () => ({})
        },
        value: {
            type: Object,
            default: null
        },
        boxTitle: {
            type: String,
            default: ""
        },
        viesButton: {
            type: Boolean,
            default: false
        },
        deleteButton: {
            type: Boolean,
            default: false
        },
        copyClientDataButton: {
            type: Boolean,
            default: false
        },
        isEnabledCopyButton: {
            type: Boolean,
            default: false
        },
        id: {
            type: Number,
            default: -1
        },
        index: {
            type: Number,
            default: -1
        },
        countryProp: {
            default: null
        },
        idNumberTypeProp: {
            default: null
        },
        copyButtonChecked: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        logo: {
            type: Boolean,
            default: false
        },
        shortName: {
            type: Boolean,
            default: false
        },
        mode: {
            type: String
        },
        permission_access: {
            default: null
        },
        sectionTitle: {
            type: String,
            default: 'app_user'
        },
        old: {
            default: () => ({})
        },
    },
    computed: {
        showLogo() {
            return permissions.getPermission(this.permission_access, 'perm_view_application.settings_crud_logo')
        },
        filteredidNumbersSelect2() {
            let filtered = this.idNumbersSelect2.filter(element => {
                let countryId = 0;
                if (this.formData.departmentCountryChecked) {
                    countryId = this.formData.departmentCountrySelected;
                } else {
                    countryId = this.formData.countrySelected;
                }
                return (
                    element.country_id == countryId ||
                    element.text == "other" ||
                    element.text == "none"
                );
            });

            let translated = [];
            filtered.forEach(element => {
                let tempElement = {...element};
                tempElement.text = this.__(element.text);
                translated.push(tempElement);
            });

            return translated;
        },
        isSelectedIdNumber() {
            let inputName = this.idNumbersSelect2.find(
                element => element.id == this.formData.idNumberType
            );
            return (
                this.formData.idNumberType != null &&
                inputName != undefined &&
                inputName.text != "none"
            );
        },
        isSelectedIdNumberSecondary() {
            let inputName = this.idNumbersSelect2.find(
                element => element.id == this.formData.idNumberSecondaryType
            );
            return (
                this.formData.idNumberSecondaryType != null &&
                inputName != undefined &&
                inputName.text != "none"
            );
        },
        isIdNumberNip() {
            let number = this.filteredidNumbersSelect2.find(obj => {
                return obj.id == this.formData.idNumberType;
            });

            return number != undefined ? number.text == "NIP" : false;
        },
        isSecondaryIdNumberNip() {
            let number = this.filteredidNumbersSelect2.find(obj => {
                return obj.id == this.formData.idNumberSecondaryType;
            });

            return number != undefined ? number.text == "NIP" : false;
        },
        isViesDisabled() {
            let countryId = -1;
            if (this.formData.departmentCountryChecked) {
                countryId = this.formData.departmentCountrySelected;
            } else {
                countryId = this.formData.countrySelected;
            }
            let country = this.countriesSelect2.find(
                element => element.id == countryId
            );

            if (country != undefined && country.eu_country != 1) {
                this.resetViesCheckboxes();
            }

            return country != undefined && country.eu_country != 1;
        },
        ...mapGetters({
            countriesSelect2: "getCountriesSelect2",
            idNumbersSelect2: "getIdNumbersTypes",
            selectedDepartment: "getSelectedSaDepartment",
            values: "getValues"
        })
    },
    methods: {
        resetViesCheckboxes() {
            this.idVies = false;
            this.idSecondaryVies = false;
        },
        countryChanged() {
            if (this.formData.departmentCountryChecked == false) {
                this.$emit("changeCountry", this.formData.countrySelected);
                this.setDefaultIdNumbersSelects();
                this.$emit("chamgeIdType", this.formData.idNumberType);
            }
        },
        departmentCountryChanged() {
            if (
                this.formData.departmentCountryChecked == true ||
                this.formData.departmentCountryChecked == "on"
            ) {
                this.$emit(
                    "changeCountry",
                    this.formData.departmentCountrySelected
                );
                this.setDefaultIdNumbersSelects();
                this.$emit("chamgeIdType", this.formData.idNumberType);
            }
        },
        setDefaultIdNumbersSelects() {
            let isDefaultSelected = false;

            this.filteredidNumbersSelect2.forEach(element => {
                if (
                    element.related_type == "other_entities" &&
                    !isDefaultSelected
                ) {
                    this.formData.idNumberType = element.id;
                    isDefaultSelected = true;
                }
            });

            if (!isDefaultSelected) {
                this.formData.idNumberType = this.filteredidNumbersSelect2[0].id;
            }

            this.setSecondIdTypeNone();
        },
        departmentCountryChange() {
            this.$set(this.formData, "departmentCountrySelected", -1);
            this.setDefaultIdNumbersSelects();
            this.$emit("changeCountry", this.formData.countrySelected);
            this.$emit("chamgeIdType", this.formData.idNumberType);
        },
        idNumberSecondaryChanged() {
            let inputName = this.idNumbersSelect2.find(
                element => element.id == this.formData.idNumberSecondaryType
            );

            if (inputName != undefined && inputName.text == "none") {
                this.formData.idNumberSecondary = "";
            }
        },
        idNumberChanged() {
            let inputName = this.idNumbersSelect2.find(
                element => element.id == this.formData.idNumberType
            );

            this.$emit("chamgeIdType", this.formData.idNumberType);
            if (inputName != undefined && inputName.text == "none") {
                this.formData.idNumber = "";
            }
        },
        updateFormCountry() {
            this.formData.countrySelected =
                this.selectedDepartment.department_country != null
                    ? this.selectedDepartment.department_country.id
                    : this.selectedDepartment.country.id;

            if (this.formData.departmentCountryChecked == false) {
                this.setDefaultIdNumbersSelects();
                this.setSecondIdTypeNone();
            }
        },
        deleteForm() {
            $(function () {
                $(".tooltip").remove();
            });
            this.$emit("delete", this.id);
        },
        copyClientData(obj) {
            this.formData.isDataCopied = !this.formData.isDataCopied;
            this.$refs.secondary_form.$data.formData = {...this.clearFormData}
        },
        copyData(obj){
            this.$refs.secondary_form.$data.formData = {...this.clearFormData}
        },
        updateForm() {
            this.$emit("input", this.formData);
        },
        idViesClick() {
            if (this.idVies == false) {
                this.idSecondaryVies = false;
            }
        },
        idSecondaryViesClick() {
            if (this.idSecondaryVies == false) {
                this.idVies = false;
            }
        },
        hasError(inputName) {
            return this.errors[`${inputName}.${this.index}`] != undefined;
        },
        getErrors(inputName) {
            return this.errors[`${inputName}.${this.index}`] != undefined
                ? this.errors[`${inputName}.${this.index}`]
                : [];
        },
        getError(inputName) {
            return this.errors[`${inputName}.${this.index}`] != undefined
                ? this.errors[`${inputName}.${this.index}`][0]
                : [];
        },
        setData(data) {
            if (Object.keys(data).length != 0) {
                for (const [key, value] of Object.entries(data)) {
                    if (value != null && value[this.index] != undefined) {
                        this.$set(this.formData, key, value[this.index]);
                    }
                }
                if (data.idNumberVies) {
                    this.idVies = true;
                } else if (data.idNumberSecondaryVies) {
                    this.idSecondaryVies = true;
                }
            }
        },
        setSecondIdTypeNone() {
            let none = this.idNumbersSelect2.find(
                element => element.text == "none"
            );

            // this.formData.idNumberSecondaryType = none.id;
        },
        getDataFromGUS(inputName) {
            let nip = this.formData[inputName];
            this.getGusInfo({nip: nip}).then(response => {
                let data = response.data;

                if (data.success == true) {
                    this.updateClientFormFromGUS(data.data[0]);

                    toastr["info"](
                        this.__("clients_data_have_been_imported")
                    ).css("border", "0px");
                } else {
                    toastr["error"](
                        this.__(
                            "the_contractor_data_could_not_be_imported_or_the_contractor_was_not_found"
                        )
                    ).css("border", "0px");
                }
            });
        },
        updateClientFormFromGUS(data) {
            this.formData.name = data.name;
            let street = data.street.replace("ul. ", "");
            street = street.concat(" ", data.propertyNumber);

            if (data.apartmentNumber != "") {
                street = street.concat("/", data.apartmentNumber);
            }

            this.formData.address1 = street;
            this.formData.zip = data.zipCode;
            this.formData.city = data.postCity;
        },
        addClientForms(quantity) {
            for (let index = 0; index < quantity; index++) {
                this.addClientForm();
            }
        },
        addClientForm() {
            this.clientsForms.push({
                id: this.rowsCount++,
                element: RegisterUserForm
            });
        },
        getSortedIdNumbersTypes() {
            let array = [...this.idNumbers];
            let arraySorted = array.sort((a, b) => (a.text > b.text ? 1 : -1));

            let otherIndex = arraySorted.findIndex(element => {
                return element.text == "other";
            });
            arraySorted.push(arraySorted.splice(otherIndex, 1)[0]);

            let noneIndex = arraySorted.findIndex(element => {
                return element.text == "none";
            });
            arraySorted.push(arraySorted.splice(noneIndex, 1)[0]);
            return arraySorted;
        },
        ...mapActions(["getGusInfo"]),
        ...mapActions(["saveCountriesTranslations"])
    },
    created() {
        this.saveCountriesTranslations(this.countryTranslations);
        this.$store.commit("pushToCountriesSelect", this.countries);
        this.$store.commit(
            "setIdNumbersTypesSelect",
            this.getSortedIdNumbersTypes()
        );


        this.$store.commit("setErrors", this.errors);
        this.$store.commit("setOld", this.old);
        if (
            this.old.copyClientData != undefined ||
            (Object.keys(this.old).length == 0 &&
                this.values.isDataCopied != undefined &&
                this.values.isDataCopied)
        ) {
            this.formData.isDataCopied = true;
        }
    },
    mounted() {
        if (
            this.old.copyClientData != undefined ||
            (Object.keys(this.old).length == 0 &&
                this.values.isDataCopied != undefined &&
                this.values.isDataCopied)
        ) {
            this.$refs.first_form.$data.copyClientDataCheckbox = true;
        }
    }
};
</script>

<style lang="scss" scoped>
.tooltip-more {
    &:hover {
        cursor: pointer;
    }
}
</style>
